import ZocksLogo from '../../../assets/images/zocks-logo-black.svg'
import { Link } from 'react-router'
import * as React from 'react'
import { classNames } from 'primereact/utils'

export interface SignupHeaderProps {
  hideAccountCreation?: boolean
  className?: string
}

export const SignupHeader = ({ hideAccountCreation = false, className }: SignupHeaderProps) => (
  <div className={classNames('auth-header', className)}>
    <img className='auth-logo' src={ZocksLogo} alt='Zocks logo' />
    {!hideAccountCreation ? (
      <div className='auth-header-text'>
        <div>New user?</div>
        <div className='auth-header-link'>
          <Link to={'/signup'}>Create an account</Link>
        </div>
      </div>
    ) : null}
  </div>
)
